import {Button, ButtonProps, Modal} from "antd";
import {forwardRef, ReactNode, useImperativeHandle, useState} from "react";
import i18n from "@/i18n/i18n.ts";

type DeleteButtonProps = {
    title?: string,
    content?: string | ReactNode,
    confirmMessage?: string,
    okText?: string,
    cancelText?: string,
    buttonText?: string,
    widthModal?: number,
    buttonProps?: ButtonProps,
    handleOk?: () => void,
    beforeOpenModal?: () => Promise<any>,
}

export interface ConfirmButtonRef {
    openModal: () => void,
    closeModal: () => void,
}

const ConfirmButton = forwardRef<ConfirmButtonRef | undefined, DeleteButtonProps>((
    {
        title,
        content,
        confirmMessage = "Confirm content",
        okText = i18n.t('button.delete'),
        cancelText = i18n.t('button.cancel'),
        buttonText = i18n.t('button.delete'),
        buttonProps,
        widthModal = 400,
        handleOk,
        beforeOpenModal,
    }: DeleteButtonProps,
    ref
) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onClickConfirmButton = async () => {
        if (beforeOpenModal) {
            const a = await beforeOpenModal();
            setIsOpen(a);
        } else {
            setIsOpen(true);
        }
    }
    const handleCancel = () => {
        setIsOpen(false);
    }

    useImperativeHandle(ref, () => ({
        openModal: () => setIsOpen(true),
        closeModal: () => setIsOpen(false),
    }));

    return (
        <>
            <Button {...buttonProps} onClick={() => onClickConfirmButton()}>
                {buttonText}
            </Button>
            <Modal
                title={title ? title : <h2 className={'h-7'}></h2>}
                open={isOpen}
                onCancel={handleCancel}
                width={widthModal}
                className={'modal-header-no-border'}
                footer={<>
                    <Button onClick={handleCancel} size={'large'}>{cancelText}</Button>
                    <Button type={"primary"} onClick={handleOk} size={'large'}>{okText}</Button>
                </>
                }
            >
                <div className={'text-lg pt-2 pb-10 text-center'}>{confirmMessage}</div>
                {content}
            </Modal>
        </>
    )
});

export default ConfirmButton;